import React from 'react';

const NextButton = ({ onClickFunc, disabled = false, word = '次へ' }) => (
  <button
    type="button"
    className="col-5 a-button a-button__top a-button--orange mb-5"
    onClick={onClickFunc}
    disabled={disabled}
  >
    {word}
  </button>
);

export default NextButton;
